import { Button, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import React, { useState } from 'react';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { useAuth0 } from '@auth0/auth0-react';
import { getAllCenterTypesMaster, updateArteFinalMaster } from '../../api/carteleriaApi';
import toast from 'react-hot-toast';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { useMaster } from '../../context/MasterContext';
import { useQuery } from '@tanstack/react-query';
import MaterialTooltip from '../../ui/tooltip/MaterialTooltip';

const FavouriteSelected = ({ row, selectedIdsFavorite, setSelectedIdsFavorite }) => {
  const { getAccessTokenSilently } = useAuth0();
  const { data: centerTypes } = useQuery(['center-types-master'], async () => {
    const token = await getAccessTokenSilently();
    return await getAllCenterTypesMaster(token);
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const { refetch } = useMaster();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (idArte, centerType) => {
    setSelectedIdsFavorite((prevSelectedIdsFavorite) => {
      return prevSelectedIdsFavorite.map((item) => {
        if (item.idArte === idArte) {
          return {
            ...item,
            centers: item.centers.includes(centerType)
              ? item.centers.filter((center) => center !== centerType)
              : [...item.centers, centerType],
          };
        }
        return item;
      });
    });
  };

  const handleConfirmUpdateFavourite = async () => {
    const token = await getAccessTokenSilently();
    const centersIds = selectedIdsFavorite.find((item) => item.idArte === row._id).centers;
    updateArteFinalMaster(token, row._id, { favourite: centersIds });
    refetch(); // TODO: esto me parece muy poco eficiente, en todo caso como mucho tendriamos que hacer el refetch de la data que se actualiza. Es decir, de la row que se actualiza. No de toda la data.
    toast.success('Favoritos actualizados con éxito');
    handleClose();
  };

  const isFavorite = (idArte, centerType) => {
    const selectedItem = selectedIdsFavorite.find((item) => item.idArte === idArte);
    return selectedItem && selectedItem.centers.includes(centerType);
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div>
        {row.issues.length > 0 && (
          <MaterialTooltip
            variation="warning"
            title={
              <React.Fragment>
                <Typography
                  style={{
                    fontWeight: 'bold',
                  }}
                  color="inherit"
                >
                  Articulo con problemas
                </Typography>

                {row?.formatos?.length > 0 && row?.centerType?.length !== 0 && row?.allCategoriesDisabled === false ? (
                  <Typography
                    variant="body2"
                    style={{
                      padding: '0 0 1rem 0',
                    }}
                  >
                    Este articulo <strong>SI</strong> se mostrará en la lista de artes finales sin embargo no se
                    mostraran todos sus formatos porque tiene los siguientes problemas.
                  </Typography>
                ) : (
                  <Typography
                    variant="body2"
                    style={{
                      padding: '0 0 1rem 0',
                    }}
                  >
                    Este articulo <strong>NO</strong> se mostrara en la lista de artes finales porque tiene los
                    siguientes problemas.
                  </Typography>
                )}

                <ul>
                  {row.issues.map((issue) => (
                    <li key={issue}>{issue}</li>
                  ))}
                </ul>
              </React.Fragment>
            }
            arrow
          >
            <IconButton className="alert-message">
              <ReportProblemIcon color="warning" />
            </IconButton>
          </MaterialTooltip>
        )}
      </div>
      <div style={{ display: 'flex', justifyContent: 'end' }}>
        <IconButton onClick={handleClick} disabled={row?.centerType?.length === 0}>
          {selectedIdsFavorite[0]?.centers?.length > 0 ? <StarIcon color="error" /> : <StarBorderIcon />}
        </IconButton>
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
          {row?.centerType?.map((centerType) => (
            <MenuItem key={centerType} onClick={() => handleMenuItemClick(row._id, centerType)}>
              {isFavorite(row._id, centerType) ? <StarIcon color="error" /> : <StarBorderIcon />}
              {centerTypes?.data.find((el) => el._id === centerType)?.type}
            </MenuItem>
          ))}

          <div style={{ display: 'flex', gap: '0.5rem', padding: '0.5rem' }}>
            <Button variant="outlined" color="error" onClick={handleConfirmUpdateFavourite}>
              Confirmar
            </Button>
            <Button variant="outlined" color="error" onClick={handleClose}>
              Cancelar
            </Button>
          </div>
        </Menu>
      </div>
    </div>
  );
};

export default FavouriteSelected;
